import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {
  MaterialCreatePayload,
  MaterialCreateResponse,
  MaterialReadResponse,
  MaterialReadSingleResponse,
  MaterialUpdatePayload,
  MaterialUpdateResponse,
} from "../interfaces";
import { catchError, retry } from 'rxjs/operators';
import { AlertService, IAlertType } from "./alert.service";
import { restBaseUrl } from "../utils/rest-url";

@Injectable({
  providedIn: 'root'
})
export class MaterialStoreService {
  private endpoint = restBaseUrl('/material');

  constructor(
    private http: HttpClient,
    private alertDispatcher: AlertService) { }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Server-side error code: ${error.status} - message: ${error.message}`;
    }
    // window.alert(errorMessage);

    this.alertDispatcher.alertConfig.message = errorMessage;
    this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;

    return throwError(() => new Error(errorMessage));
  }

  public getMaterials(): Observable<MaterialReadResponse> {
    return this.http.get<MaterialReadResponse>(this.endpoint + '/get_material')
      .pipe(retry(3), catchError(this.handleError.bind(this)));
  }

  public getMaterial(materialID: number): Observable<MaterialReadSingleResponse> {
    return this.http.get<MaterialReadSingleResponse>(
      `${this.endpoint}/get_single_material/${materialID}`
    ).pipe(retry(3), catchError(this.handleError.bind(this)));
  }

  public updateMaterial(material: MaterialUpdatePayload): Observable<MaterialUpdateResponse> {
    return this.http.put<MaterialUpdateResponse>(
      `${this.endpoint}/update_material`,
      material
    ).pipe(retry(3), catchError(this.handleError.bind(this)));
  }

  public addMaterial(material: MaterialCreatePayload): Observable<MaterialCreateResponse> {
    return this.http.post<MaterialCreateResponse>(
      `${this.endpoint}/add_material`,
      material
    ).pipe(retry(3), catchError(this.handleError.bind(this)));
  }

  public deleteMaterial(materialID: number): Observable<string> {
    return this.http.delete(
      `${this.endpoint}/delete_material?material_id=${materialID}`,
      { responseType: 'text'}
    ).pipe(retry(3), catchError(this.handleError.bind(this)));
  }

  public deleteMaterials(materialID: number): Observable<string> {
    return this.deleteMaterial(materialID);
  }

}
